import * as yup from "yup";
import { validarMoedaReal } from "../../core/utils/validarMoedaReal";

const moedaValidation = (valor?: string) => {
    return !validarMoedaReal(valor, 0.00, undefined, true);
};

export const atualizarPrecoSchema = yup.object().shape({
    preco: yup.string().test('preco', 'Valor inválido', moedaValidation),
    precoSemDesconto: yup.string().optional().test('precoSemDesconto', 'Valor inválido', (valor) => {
        return !valor || moedaValidation(valor);
    })
});
